/* OREN — Lenis Smooth Scroll + Logo Morph (v16 — logo appended to BODY, escapes all stacking contexts) */
(function(){
  'use strict';

  if (document.body.classList.contains('coming-soon-active')) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isMobile = window.matchMedia('(max-width: 760px)').matches;
  const root = document.documentElement;

  let frameUpdate = null;

  // ============================================
  // LENIS
  // ============================================
  let lenis = null;
  function initLenis(){
    if (reduced || isMobile || !window.Lenis) return;
    lenis = new window.Lenis({
      duration: 1.15,
      easing: function(t){ return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      orientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.4,
      lerp: 0.08,
      syncTouch: false
    });
    window.lenis = lenis;
    lenis.on('scroll', function(){ if (frameUpdate) frameUpdate(); });
    function raf(time){ lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);

    document.addEventListener('click', function(e){
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      if (href === '#' || href.length < 2) return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: -70, duration: 1.4 });
    });
    root.classList.add('lenis-active');
  }
  if (!reduced && !isMobile && !window.Lenis){
    const s = document.createElement('script');
    s.src = 'https://unpkg.com/lenis@1.1.13/dist/lenis.min.js';
    s.onload = initLenis;
    document.head.appendChild(s);
  } else if (window.Lenis){ initLenis(); }

  // ============================================
  // HEADER PROGRESS
  // ============================================
  function makeHeaderProgress(){
    const TICKER_RANGE = 44;
    const NAV_RANGE = 130;
    return function(){
      const y = window.scrollY || window.pageYOffset;
      const tickerP = Math.min(1, Math.max(0, y / TICKER_RANGE));
      const navP = Math.min(1, Math.max(0, y / NAV_RANGE));
      root.style.setProperty('--ticker-progress', tickerP.toFixed(4));
      root.style.setProperty('--nav-progress', navP.toFixed(4));
    };
  }

  // ============================================
  // LOGO MORPH — the flying logo is CLONED and appended to <body>,
  // which makes it a child of the root stacking context. Original is hidden.
  // No CSS in the original DOM can trap it anymore.
  // ============================================
  function init(){
    const setHeaderProgress = makeHeaderProgress();
    const origHeroLogoImg = document.querySelector('.hero-logo-big img');
    const heroLogoWrap = document.querySelector('.hero-logo-big');
    const navLogoSlot = document.querySelector('.nav-logo-center img');
    const navLogoLink = document.querySelector('.nav-logo-center');
    const hero = document.querySelector('.hero-immersive');

    const morphActive = !isMobile && origHeroLogoImg && heroLogoWrap && navLogoSlot && navLogoLink && hero;
    if (morphActive){ root.classList.add('has-logo-morph'); }

    let heroHeight = hero ? hero.offsetHeight : 0;
    let ticking = false;
    let startBox = null;
    let flyingLogo = null; // the clone in <body>

    function buildFlyingLogo(){
      if (!morphActive) return;

      // Capture START geometry from the original logo (in its natural place)
      heroHeight = hero.offsetHeight;
      const sy = window.scrollY || window.pageYOffset;
      const r = origHeroLogoImg.getBoundingClientRect();
      startBox = {
        cx: r.left + r.width / 2,
        cyDoc: r.top + r.height / 2 + sy,
        w: r.width,
        h: r.height
      };

      // Reserve the original space so the hero layout doesn't collapse
      heroLogoWrap.style.height = r.height + 'px';
      heroLogoWrap.style.display = 'flex';
      heroLogoWrap.style.alignItems = 'center';
      heroLogoWrap.style.justifyContent = 'center';

      // Hide the original — the clone takes over visually
      origHeroLogoImg.style.visibility = 'hidden';

      // Build the clone if not already built
      if (!flyingLogo){
        flyingLogo = document.createElement('img');
        flyingLogo.src = origHeroLogoImg.src;
        flyingLogo.alt = '';
        flyingLogo.className = 'oren-flying-logo';
        flyingLogo.setAttribute('aria-hidden', 'true');
        document.body.appendChild(flyingLogo);
      }
    }

    function update(){
      setHeaderProgress();

      if (morphActive && startBox && flyingLogo){
        const sy = window.scrollY || window.pageYOffset;
        const morphEnd = Math.max(1, heroHeight * 0.62);
        const progress = Math.min(1, Math.max(0, sy / morphEnd));
        const eased = progress * progress * (3 - 2 * progress);

        // Live target: nav slot this frame (it moves up as ticker collapses)
        const navRect = navLogoLink.getBoundingClientRect();
        const navCx = navRect.left + navRect.width / 2;
        const navCy = navRect.top + navRect.height / 2;
        const navImgRect = navLogoSlot.getBoundingClientRect();
        const targetW = navImgRect.width > 10 ? navImgRect.width : 110;

        const startCyNow = startBox.cyDoc - sy;
        const curCx = startBox.cx + (navCx - startBox.cx) * eased;
        const curCy = startCyNow + (navCy - startCyNow) * eased;
        const curW  = startBox.w + (targetW - startBox.w) * eased;
        const ratio = startBox.h / startBox.w;
        const curH = curW * ratio;

        flyingLogo.style.width = curW.toFixed(2) + 'px';
        flyingLogo.style.height = 'auto';
        flyingLogo.style.left = (curCx - curW / 2).toFixed(2) + 'px';
        flyingLogo.style.top = (curCy - curH / 2).toFixed(2) + 'px';

        const heroTop = document.querySelector('.hero-immersive-top');
        const heroBottom = document.querySelector('.hero-immersive-bottom');
        const fade = Math.max(0, 1 - progress * 1.6);
        if (heroTop) heroTop.style.opacity = fade;
        if (heroBottom) heroBottom.style.opacity = fade;
      }

      ticking = false;
    }

    frameUpdate = function(){ if (!ticking){ requestAnimationFrame(update); ticking = true; } };
    function onScroll(){ if (!ticking){ requestAnimationFrame(update); ticking = true; } }

    function onResize(){
      const nowMobile = window.matchMedia('(max-width: 760px)').matches;
      if (nowMobile && morphActive){
        root.classList.remove('has-logo-morph');
        if (flyingLogo && flyingLogo.parentNode){ flyingLogo.parentNode.removeChild(flyingLogo); flyingLogo = null; }
        origHeroLogoImg.style.visibility = '';
        heroLogoWrap.style.height = '';
        const ht = document.querySelector('.hero-immersive-top');
        const hb = document.querySelector('.hero-immersive-bottom');
        if (ht) ht.style.opacity = '';
        if (hb) hb.style.opacity = '';
        return;
      } else if (morphActive){
        root.classList.add('has-logo-morph');
      }
      buildFlyingLogo();
      update();
    }

    function setup(){ buildFlyingLogo(); update(); }
    setup();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('load', function(){ setTimeout(setup, 150); });
    if (origHeroLogoImg && !origHeroLogoImg.complete){
      origHeroLogoImg.addEventListener('load', function(){ setTimeout(setup, 50); });
    }
    setTimeout(setup, 500);

    initScrollReveals();
  }

  // ============================================
  // SCROLL REVEALS
  // ============================================
  function initScrollReveals(){
    if (!('IntersectionObserver' in window)) return;
    const targets = document.querySelectorAll(
      '[data-scroll-reveal], section h2, section .product-card, .product-grid > *, .journal-card, .footer h4, .footer-brand'
    );
    targets.forEach(function(el){ el.classList.add('scroll-reveal'); });
    const obs = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting){ entry.target.classList.add('is-revealed'); obs.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -80px 0px', threshold: 0.05 });
    targets.forEach(function(el){ obs.observe(el); });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(init, 100); });
  } else {
    setTimeout(init, 100);
  }
})();
